import api from "../api/config";
import { ENDPOINTS } from "../api/endpoints";

/**
 * Frontend API service for Round Robin booking distribution configuration.
 * When enabled, bookings are distributed evenly across active admins.
 * Returns: { success: boolean, data?: object, error?: string, message?: string }
 */
export const roundRobinService = {
  /**
   * Get global Round Robin configuration.
   * 
   * @returns {Promise<Object>} { success: boolean, data: { roundRobinEnabled: boolean }, error?: string }
   */
  getRoundRobinConfig: async () => {
    try {
      const response = await api.get(ENDPOINTS.GET_ROUND_ROBIN_CONFIG);
      return response.data;
    } catch (error) {
      // Extract error message from API response or use fallback
      const errorMessage = error?.response?.data?.error || error?.message || "Failed to fetch Round Robin configuration";
      throw new Error(errorMessage);
    }
  },

  /**
   * Update global Round Robin configuration.
   * 
   * @param {Object} data - { roundRobinEnabled: boolean }
   * @returns {Promise<Object>} { success: boolean, message?: string, data?: object, error?: string }
   */
  updateRoundRobinConfig: async (data) => {
    try {
      const response = await api.put(ENDPOINTS.UPDATE_ROUND_ROBIN_CONFIG, data);
      return response.data;
    } catch (error) {
      // Extract error message from API response or use fallback
      const errorMessage = error?.response?.data?.error || error?.message || "Failed to update Round Robin configuration";
      throw new Error(errorMessage);
    }
  },
};
